import axios from 'axios';

const API_URL = '/api';

const analytics = {
    trackPageView: async (path) => {
        try {
            await axios.post(`${API_URL}/analytics/track`, { path });
        } catch (error) {
            // Silent fail - don't interrupt user experience
            console.error('Analytics tracking failed:', error);
        }
    },

    getSummary: async () => {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/analytics/summary`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    }
};

export default analytics;
